import {Routes} from '@angular/router';
import {HomeComponent} from "./main-pages/home/home.component";
import {RulesComponent} from "./main-pages/rules/rules.component";
import {ContactsComponent} from "./main-pages/contacts/contacts.component";
import {PrivacyPolicyComponent} from "./main-pages/privacy-policy/privacy-policy.component";
import {QaComponent} from "./main-pages/qa/qa.component";
import {sxOnlyGuard} from "./main-pages/landing/sx-only.guard";

const landingComponent = () => import('./main-pages/landing/landing.component').then(m => m.LandingComponent)

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: 'rules',
        component: RulesComponent
    },
    {
        path: 'contacts',
        component: ContactsComponent
    },
    {
        path: 'privacy_policy',
        component: PrivacyPolicyComponent
    },
    {
        path: 'qa',
        component: QaComponent
    },
    {
        path: 'partners',
        loadComponent: () => import('./main-pages/partners/partners.component').then(m => m.PartnersComponent)
    },
    {
        path: 'blog',
        loadComponent: () => import('./main-pages/blog-list/blog-list.component').then(m => m.BlogListComponent)
    },
    {
        path: 'blog/:id',
        loadComponent: () => import('./main-pages/blog-article/blog-article.component').then(m => m.BlogArticleComponent)
    },
    {
        path: 'free-sex-chat',
        data: {slug: 'free-sex-chat'},
        canActivate: [sxOnlyGuard],
        loadComponent: landingComponent
    },
    {
        path: 'virtual-sex-chat',
        data: {slug: 'virtual-sex-chat'},
        canActivate: [sxOnlyGuard],
        loadComponent: landingComponent
    },
    {
        path: 'anonymous-chat',
        data: {slug: 'anonymous-chat'},
        canActivate: [sxOnlyGuard],
        loadComponent: landingComponent
    },
    {
        path: 'sexting',
        data: {slug: 'sexting'},
        canActivate: [sxOnlyGuard],
        loadComponent: landingComponent
    },
    {
        path: 'adult-chat',
        data: {slug: 'adult-chat'},
        canActivate: [sxOnlyGuard],
        loadComponent: landingComponent
    },
    {
        path: 'login',
        loadChildren: () => import('./login-module/login.module').then(m => m.LoginModule)
    },
    {
        path: 'auth',
        loadChildren: () => import('./registration-module/registration.module').then(m => m.RegistrationModule)
    },
    {
        path: 'chat',
        loadChildren: () => import('./chat-module/chat.module').then(m => m.ChatModule)
    },
    {
        path: 'test',
        loadChildren: () => import('./test-page-module/test-page-module.module').then(m => m.TestPageModuleModule)
    },
    {path: '**', redirectTo: ''}
]
